import Axios from '@/utils/http'
// 申请为伙伴
export function enablePartner(data) {
    return Axios.postCom(window.Glod["ccex-appstore"] + '/store/api/formalPartner/apply ', data)
}